let fixedElements = [];

$.fn.ScreenHeight = function(options)
{
  let self = this;

  self.status = {
    managed: false,
  };

  self.check = function()
  {
    // reset if managed
    if (self.status.managed){
      self.status.managed = false;
      self.css({
        'min-height': '',
        'height': '',
      });
    }

    // check heights
    let selfHeight = self.outerHeight(false),
      windowHeight = $(window).height(),
      targetHeight = windowHeight;

    if (self.find(options.inner).length){
      let innerHeight = self.find(options.inner).outerHeight(false);
      if (innerHeight > windowHeight){
        targetHeight = innerHeight;
      }
    }
    if (selfHeight > windowHeight){
      self.status.managed = true;
      self.css({
        'min-height': targetHeight + "px",
        'height': targetHeight + "px",
      });
    }
  };

  return function()
  {
    $(window).on("load orientationchange resize", self.check);
    self.find("img").on("load", function(){
      self.check();
    });
    self.check();
    return self;
  }();
};

export default {

  elements: fixedElements,

  init: function(options) {
    if (options.selector == undefined){
      options.selector = '.screen';
    }
    if (options.inner == undefined){
      options.inner = '.screen__content';
    }
    $(options.selector).each(function(){
      let screenFixed = $(this).ScreenHeight(options);
      fixedElements.push(screenFixed);
    });
  },

}
